import { adaptEventHandler } from '../../../utils';
import { Fragment } from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import { IconComponent } from '../../icon';
var boxStyles = xcss({
  display: 'flex',
  alignItems: 'center',
  gap: 'space.050'
});
// Forge doesn't import individual Icon components and instead use glyph names passed into an Icon component to render the icon
// We are changing the behaviour of Button to support our version of icons here
var createButtonChildren = function createButtonChildren(_ref) {
  var iconAfter = _ref.iconAfter,
    iconBefore = _ref.iconBefore,
    children = _ref.children,
    render = _ref.render;
  var buttonChildren = children === null || children === void 0 ? void 0 : children.map(function (c) {
    return /*#__PURE__*/React.createElement(Fragment, {
      key: c.key
    }, render(c));
  });
  if (!iconAfter && !iconBefore) {
    return buttonChildren;
  }
  return /*#__PURE__*/React.createElement(Box, {
    xcss: boxStyles
  }, iconBefore && /*#__PURE__*/React.createElement(IconComponent, {
    glyph: iconBefore,
    label: iconBefore
  }), /*#__PURE__*/React.createElement(Fragment, null, buttonChildren), iconAfter && /*#__PURE__*/React.createElement(IconComponent, {
    glyph: iconAfter,
    label: iconAfter
  }));
};
/**
 * Mapping the deprecated 'none' spacing to 'compact'
 */
var mapDeprecatedSpacing = function mapDeprecatedSpacing(spacing) {
  return spacing === 'none' ? 'compact' : spacing;
};

/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This component was generated against an existing platform component.
 * If you are seeing lint errors in this file, it means that this file's dependencies have been modified and the component will need to be regenerated.
 *
 * Please view https://hello.atlassian.net/wiki/spaces/ECO/pages/3358130330/How+to+Regenerate+UI+Kit+Components for more information on how to proceed.
 *
 * For further questions, please ping the #help-forge-ui channel.
 *
 * @codegen <<SignedSource::2800db0a1844d9a8aa710a8fd0724501>>
 * @codegenId #button
 * @codegenCommand yarn workspace @atlassian/forge-ui codegen button
 * @codegenParams { "defineOwnType": true, "props": { "children": {"value": "createButtonChildren({ iconAfter, iconBefore, children: props.forgeDoc.children, render: props.render })" }, "autoFocus": true, "overlay": false, "isDisabled": true, "isSelected": true, "onBlur": { "value": "adaptEventHandler(onBlur)" }, "onClick": { "value": "adaptEventHandler(onClick)" }, "onFocus": { "value": "adaptEventHandler(onFocus)" }, "spacing": { "value": "mapDeprecatedSpacing(spacing)" }, "testId": true, "shouldFitContainer": true, "appearance": true, "type": true, "iconAfter": { "replaceLine": true }, "iconBefore": { "replaceLine": true } } }
 * @codegenDependency ../../../../../../../design-system/button/src/new-button/variants/default/types.tsx <<SignedSource::b9aec5245f14d39bd330fbc759b068dd>>
 * @codegenDependency ../../../../../../../design-system/button/src/new-button/variants/types.tsx <<SignedSource::e02baeacd709a2faae3cf14a0e45b694>>
 * @codegenDependency ../../../../../../../design-system/button/src/new-button/variants/default/use-default-button.tsx <<SignedSource::6d7b8d1f729d119dcf1d3aef067dbc6e>>
 * @codegenDependency ../../../../../../../design-system/button/src/new-button/variants/default/button.tsx <<SignedSource::14882a31566ae77d011a3ccd7907a4e3>>
 */
/* eslint @repo/internal/codegen/signed-source-integrity: "warn" */
import React from 'react';
import PlatformButton from '@atlaskit/button/new';

// Define the type for Button as ButtonProps at the top of this file

export var Button = function Button(props) {
  var _ref2 = props.forgeDoc.props,
    autoFocus = _ref2.autoFocus,
    isDisabled = _ref2.isDisabled,
    isSelected = _ref2.isSelected,
    onBlur = _ref2.onBlur,
    onClick = _ref2.onClick,
    onFocus = _ref2.onFocus,
    spacing = _ref2.spacing,
    testId = _ref2.testId,
    shouldFitContainer = _ref2.shouldFitContainer,
    appearance = _ref2.appearance,
    type = _ref2.type,
    iconAfter = _ref2.iconAfter,
    iconBefore = _ref2.iconBefore;
  return /*#__PURE__*/React.createElement(PlatformButton, {
    children: createButtonChildren({
      iconAfter: iconAfter,
      iconBefore: iconBefore,
      children: props.forgeDoc.children,
      render: props.render
    }),
    autoFocus: autoFocus,
    isDisabled: isDisabled,
    isSelected: isSelected,
    onBlur: adaptEventHandler(onBlur),
    onClick: adaptEventHandler(onClick),
    onFocus: adaptEventHandler(onFocus),
    spacing: mapDeprecatedSpacing(spacing),
    testId: testId,
    shouldFitContainer: shouldFitContainer,
    appearance: appearance,
    type: type
  });
};
/**
 * @codegenEnd
 */